import React from "react";
export const Mandatory = () => {
  return <span className="text-danger"> * </span>;
};
